export function initializeInputFile() {
  $(".input-file__input").each(function () {
    $(this).on("change", function () {
      if ($(this).val()) {
        const inputValue = $(this).val().split(/\\/);
        const inputWrapper = $(this).closest(".input-file");
        updateInputFile(inputWrapper, inputValue[inputValue.length - 1]);
      } else {
        resetInputFile($(this).closest(".input-file"));
      }
    });
  });

  $(".input-file__reset").click(function (e) {
    e.preventDefault();
    resetInputFile($(this).closest(".input-file"));
  });
}

function updateInputFile(inputWrapper, fileName) {
  const selectedContainer = inputWrapper.find(".input-file__selected-value");
  const resetButton = inputWrapper.find(".input-file__reset");
  const uploadButton = inputWrapper.find(".input-file__button");

  selectedContainer.empty().append(fileName);
  resetButton.removeClass("d-none");
  uploadButton.empty().append(uploadButton.data("replace"));
}

function resetInputFile(inputWrapper) {
  const resetButton = inputWrapper.find(".input-file__reset");
  const input = inputWrapper.find(".input-file__input");
  const selectedContainer = inputWrapper.find(".input-file__selected-value");
  const uploadButton = inputWrapper.find(".input-file__button");

  resetButton.addClass("d-none");
  input.val("");
  selectedContainer.empty();
  uploadButton.empty().append(uploadButton.data("original"));
}
